import React, { useState, useEffect } from 'react';
import Welcome from '../welcome/Welcome';
import Signup from '../signup/Signup';
import Login from '../login/Login';
import AdminLogin from '../adminLogin/AdminLogin';
import PasswordRecovery from '../passwordRecovery/PasswordRecovery';
import Companies from '../companies/Companies';
import AdminCompanies from '../admin/companies/Companies';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import './WelcomeLayout.css';
import logo from '../../img/logo.png'

const WelcomeLayout = (props) => {

    const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        proveedor: {
            nit: '',
            razonSocial: '',
            tel: '',
            email: ''
        },
        loading: true,
        error: {}
    });

    useEffect(() => {
        if(!sessionStorage.getItem('estado')){
            props.history.push('/');
            return 0;
        }

        if(sessionStorage.getItem('proveedor')){
            props.history.push('/companies');
            return 0;
        }

    }, []);

    return(
        <div className="welcome-layout-main">

            <div className="header">
                <div className='welcome-logo-container'>
                    <img className='welcome-logo' src={ logo } />
                </div>
                <div className='welcomelayout-header-alert'>
                    <Alert variant='info' >Señor proveedor en este portal encontrará la información generada a partir el dia <strong>1ro de enero de 2023</strong></Alert>
                </div>
            </div>


            <div className='content'>
                <Switch>
                    <Route path="/signup" component={Signup} />
                    <Route path="/login" component={Login} />
                    <Route path="/recovery-password" component={PasswordRecovery} />
                    <Route path="/admin-login" component={AdminLogin} />
                    <Route path="/companies" component={Companies} />
                    <Route path="/admin-companies" component={AdminCompanies} />
                    <Route path="/" component={Welcome} />
                </Switch>
            </div>
            <div className='footer-container'>
                <div className='footer'>
                <div><Link style={{ color: 'white' }} to='/admin-login'>Acceso administrador</Link></div>
                <div>Supertiendas Cañaveral S.A. y Galeria y Cia S.A.</div>
                </div>
            </div>
        </div>
    );
}

export default WelcomeLayout